import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../ui/dialog";
import { developmentEmail } from "../../../shared/development-profile.ts";
import {
  roomDialogClass,
  roomDialogDescriptionClass,
  roomDialogTitleClass,
  roomFormClass,
  roomFormNoteClass,
  roomInputClass,
  roomLabelClass,
} from "../home/room-form";
export function DevelopmentSignIn({
  onSubmit,
}: {
  onSubmit: (_profile: { name: string; email: string }) => void;
}) {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="flex min-h-11 w-full justify-start gap-2.75 rounded-sm bg-zinc-950 px-3 py-0 hover:bg-background">
          <span
            aria-hidden="true"
            className="grid size-5.5 place-items-center rounded-full bg-white text-sm font-black text-blue-500"
          >
            G
          </span>
          {t("auth.continueWithGoogle")}
          <small className="ml-auto rounded-sm bg-primary/18 px-1.5 py-0.5 text-xs tracking-wider text-indigo-200 uppercase">
            {t("auth.developmentBadge")}
          </small>
        </Button>
      </DialogTrigger>
      <DialogContent className={roomDialogClass}>
        <DialogHeader>
          <DialogTitle className={roomDialogTitleClass}>{t("auth.developmentTitle")}</DialogTitle>
          <DialogDescription className={roomDialogDescriptionClass}>
            {t("auth.developmentDescription")}
          </DialogDescription>
        </DialogHeader>
        <form
          className={roomFormClass}
          onSubmit={(event) => {
            event.preventDefault();
            if (name.trim()) onSubmit({ name: name.trim(), email: developmentEmail(name) });
          }}
        >
          <div>
            <Label htmlFor="dev-name" className={roomLabelClass}>
              {t("join.displayName")}
            </Label>
            <Input
              id="dev-name"
              required
              maxLength={80}
              autoComplete="name"
              value={name}
              onChange={(event) => setName(event.target.value)}
              className={roomInputClass}
            />
          </div>
          <div>
            <Label htmlFor="dev-email" className={roomLabelClass}>
              {t("auth.testEmail")}
            </Label>
            <Input
              id="dev-email"
              readOnly
              value={name.trim() ? developmentEmail(name) : ""}
              tabIndex={-1}
              className={roomInputClass}
            />
            <p className={roomFormNoteClass}>{t("auth.testEmailHint")}</p>
          </div>
          <DialogFooter>
            <Button type="button" variant="ghost" onClick={() => setOpen(false)}>
              {t("common.cancel")}
            </Button>
            <Button type="submit" disabled={!name.trim()}>
              {t("join.submit")}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
